<template>
  <div id="ContentTypes" class="content-types">
    <b-list-group horizontal="md">
      <b-list-group-item button v-for="(type, index) in types" :key="index"
        class="content-types-item" :disabled="disable"
        :active="activeButton === type.name" @click="buttonAction(type.name)">
        {{ type.text }}
      </b-list-group-item>
    </b-list-group>
    <br>
  </div>
</template>

<script>

import { statusFilters, statusTranslates } from '@/config/content/statuses'

export default {
  name: 'ContentTypes',
  data() {
    return {
      activeButton: null
    }
  },
  props: {
    isCurator: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    types: {
      default() {
        return [
          { name: 'все', text: 'Все' },
          { name: statusFilters.rejected, text: statusTranslates.rejected },
          { name: statusFilters.await, text: statusTranslates.await },
          { name: statusFilters.draft, text: statusTranslates.draft },
          { name: statusFilters.accepted, text: statusTranslates.accepted },
          { name: statusFilters.removed, text: statusTranslates.removed }
        ]
      }
    }
  },
  mounted() {
    if (this.$cookies.isKey('contentButtons') && this.$cookies.isKey('activeContentButtons')
      && this.$cookies.get('activeContentButtons') === 'true') {
      this.buttonAction(this.$cookies.get('contentButtons'))
      this.$cookies.set('activeContentButtons', false, '5h')
    } else {
      this.buttonAction('все')
      this.$cookies.set('contentButtons', 'все', '5h')
    }
  },
  methods: {
    buttonAction(type) {
      if (this.activeButton !== type) {
        this.$cookies.set('contentButtons', type, '5h')
        this.activeButton = type
        this.$emit('filter', type)
      }
    }
  }
}
</script>

<style scoped>
.content-types-item {
  padding: 0 10px !important;
  line-height: 1.3rem;
  height: 50px;
}
</style>
